import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';
import { ListChecks } from 'lucide-react';
import { Card, EmptyState, StatusPill, TableSkeleton } from '@/components/ui';
import { useRecentJobs } from '@/hooks/useJobs';
import { formatRelative } from '@/utils/format';
import { JOB_STATE, JOB_TYPE_LABELS, label } from '@/utils/labels';

/** The newest few jobs, with a way to all of them. */
export function RecentJobsCard(): ReactNode {
  const recent = useRecentJobs();
  const jobs = recent.data?.items ?? [];

  return (
    <Card
      title="Последние задачи"
      icon={ListChecks}
      flush
      actions={
        <Link to="/jobs" className="btn btn-ghost btn-sm">
          Все задачи
        </Link>
      }
    >
      {recent.isPending ? (
        <TableSkeleton rows={3} columns={3} />
      ) : jobs.length === 0 ? (
        <EmptyState icon={ListChecks} message="Задач ещё не было" />
      ) : (
        <div className="table-scroll">
          <table>
            <tbody>
              {jobs.map((job) => (
                <tr key={job.id}>
                  <td title={job.type}>
                    {label(JOB_TYPE_LABELS, job.type)}
                    <div className="faint text-sm">{formatRelative(job.createdAt)}</div>
                  </td>
                  <td className="shrink">
                    <StatusPill map={JOB_STATE} status={job.state} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}
